import MissingSomethingModalButton from '@/creditflowresearch/ui/common/components/MissingSomethingModalButton';
import ResearchTile from '@/creditflowresearch/ui/components/research/components/ResearchTile';
import { BondsTileWithFallback } from '@/creditflowresearch/ui/components/bonds/BondsTile';
import { TraceTileWithFallback } from '@/creditflowresearch/ui/components/trace/TraceTile';
import { ArticlesTilesWithFallback } from '@/creditflowresearch/ui/components/creditFlow/articles/ArticlesTiles';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import DealPageTile from '@/creditflowresearch/ui/components/deals/DealTiles/DealPageTile';
import DealTileWithFallback from '@/creditflowresearch/ui/components/deals/DealTiles/DealTileWithFallback';
import { Product } from '@/creditflowresearch/domain/Product';
import { AbsProduct } from '@/creditflowresearch/domain/Product';
import DealHeader from '@/creditflowresearch/ui/components/deals/Deal/DealHeader';
import { checkAccessByProducts } from '@/creditflowresearch/application/User/access/checkAccessByProducts';
import { checkAccessByRegions } from '@/creditflowresearch/application/User/access/checkAccessByRegions';
import { useParentPageContext } from '@/creditflowresearch/application/ParentPageContext';
import { RoadshowsTileWithFallback } from '@/creditflowresearch/ui/components/Roadshows/Tile';
import { OpenAccessDealProvider } from '@/creditflowresearch/application/User/access/grants/OpenAccessDealContext';

import spaceStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';

const Deal = () => {
  const { products: userProducts, regions: userRegions } = useUserPlanContext();
  const { deal } = useParentPageContext();
  const isAbsProduct = Product.isOfType(deal.product.id, AbsProduct.TYPE);
  const userAccessChecks = [
    checkAccessByRegions([deal?.country?.region?.id], userRegions),
    checkAccessByProducts([deal?.product?.id], userProducts),
  ];

  return (
    // TODO: remove the provider when the European market opening period ends
    <OpenAccessDealProvider deal={ deal }>
      <DealHeader />
      <DealTileWithFallback userAccessChecks={ userAccessChecks }>
        <DealPageTile />
      </DealTileWithFallback>
      <RoadshowsTileWithFallback userAccessChecks={ userAccessChecks } />
      <div className={ spaceStyles.mtl }>
        <ArticlesTilesWithFallback
          isSubscribeButtonVisible={ false }
          userAccessChecks={ userAccessChecks }
        />
      </div>
      { isAbsProduct && (
        <>
          <BondsTileWithFallback userAccessChecks={ userAccessChecks } />
          <TraceTileWithFallback userAccessChecks={ userAccessChecks } withChart />
          <ResearchTile />
        </>
      ) }
      <MissingSomethingModalButton />
    </OpenAccessDealProvider>
  );
};
export default Deal;
